// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"9baee053","627":"a6f24408","653":"662a2f71","738":"65dbdea2","923":"2ff829a9"}[chunkId] + ".chunk.js";
};